import { useCallback, useMemo } from 'react'

import { RootState, useAppDispatch } from '@editor/store/app'
import { useSelector } from 'react-redux'

import { undoWorkingCircle } from '../store'

const useUndo = () => {
  const dispatch = useAppDispatch()
  const workingCirclePoint = useSelector((state: RootState) => state.bpToolCircle.workingCirclePoint)
  const canUndo = useMemo(() => !!workingCirclePoint, [workingCirclePoint])

  /**
   * Handles the undo action for the working circle if exists.
   */
  const handleUndo = useCallback(() => {
    if (!canUndo) return

    dispatch(undoWorkingCircle())
  }, [canUndo, dispatch])

  return {
    handleUndo,
    canUndo,
  }
}

export default useUndo
